var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fcfcfc;opacity:0;}.b{fill:#fff;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 12,
    height: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.29 2.499)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11,8.46v1.5a1,1,0,0,1-1.09,1A9.894,9.894,0,0,1,5.595,9.425a9.759,9.759,0,0,1-3-3A9.894,9.894,0,0,1,1.06,2.09a1,1,0,0,1,1-1.09h1.5a1,1,0,0,1,1,.86,6.424,6.424,0,0,0,.35,1.405A1,1,0,0,1,4.68,4.32l-.635.635a8,8,0,0,0,3,3L7.68,7.32a1,1,0,0,1,1.055-.225,6.424,6.424,0,0,0,1.405.35A1,1,0,0,1,11,8.46Z",
    transform: "translate(-1.29 -2.499)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.1a207c0c3975293e15242d1295ea11fc.svg";
export { ForwardRef as ReactComponent };